import { useQuery } from 'react-query';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
export type Region = {
  pk: number;
  region: string;
}[];
export const fetchRegion = async () => {
  const {
    data
  } = await http.get(`${API_ENDPOINTS.REGION}`);
  return data;
};
export const useRegionQuery = () => {
  return useQuery<Region, Error>([API_ENDPOINTS.REGION], fetchRegion, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};